<template>
  <Teleport to="body">
    <div v-show="modalActive" class="modal-bg" @click.self="$emit('close')">
      <div class="modal" :class="size">
        <div class="modal-header">
          <h2>Bạn có thật sự muốn xóa?</h2>
          <p>Bạn có thể sẽ không thể phục hồi thông tin này!</p>
          <p>Tiếp tục xóa?</p>
        </div>

        <div class="modal-content">
          <button class="cancel" :disabled="requestLoading" @click="$emit('close')">Hủy</button>
          <!-- <button class="delete" @click="$emit('delete')">
            <i class="fa-solid fa-trash"></i> Yes, Delete</button> -->
          <button class="delete" :class="{ loading: requestLoading }" :disabled="requestLoading" @click="$emit('delete')">
            <p class="btn-text"><i class="fa-solid fa-trash"></i> Xóa</p>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script>
export default {
  props: {
    requestLoading: {
      type: Boolean,
      require: false,
      default: false
    },
    modalActive: {
      type: Boolean,
      require: false,
      default: false
    },
    size: {
      type: String,
      require: false,
      default: 'default'
    }
  },
  emits: ['close', 'delete']
}
</script>
<style scoped>
.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 4;
}

.modal {
  padding: 16px;
  background: #fff;
  width: 700px;
  align-self: center;
  border-radius: 12px;
  width: 450px;
}

.modal-header {
  margin-bottom: 60px;
}

.modal-header h2 {
  margin-bottom: 10px;
}

.modal-header p {
  color: #ababab;
  font-size: 15px;
}

.modal-content {
  display: flex;
  justify-content: flex-end;
}

.modal-content button {
  position: relative;
  margin-left: 20px;
  padding: 10px 20px;
  border-radius: 15px;
  outline: none;
  border: none;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
}

.modal-content .delete {
  color: #fff;
  background: red;
}

.modal-content .cancel {
  color: #969393;
  background: #efebeb;
}

.modal-content i {
  margin-right: 5px;
}

.btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }
</style>
